import { all, call } from "redux-saga/effects";

import { loginSaga } from "./login/login.saga";

/***** MASTERS *****/
import { userTypeMasterSaga } from "./master/userType/userType.saga";
import { branchMasterSaga } from "./master/branch/branch.saga";
import { departmentMasterSaga } from "./master/department/department.saga";
import { productMasterSaga } from "./master/product/product.saga";
import { lenderMasterSaga } from "./master/lender/lender.saga";
import { leadsMasterSaga } from "./master/leads/leads.saga";
import { generalSaga } from "./general/general.saga";
import { staffMasterSaga } from "./master/staff/staff.saga";
import { companySaga } from "./superAdmin/company/company.saga";
import { profileSaga } from "./profile/profile.saga";
import { attendanceSaga } from "./operation/attendance/attendance.saga";
import { preproposalsSaga } from "./operation/preProposals/preproposals.saga";
import { diallerPushLogSaga } from "./report/diallerPushLog/diallerPushLog.saga";
import { searchBusinessDetailsSaga } from "./report/viewBusinessDetails/viewBusiness.saga";
import { callbackSaga } from "./report/callBack/callBack.saga";
import { statusCountSaga } from "./report/status-count/status-count.saga";
import { tcnResponseSaga } from "./report/tcnResponse/tcnResponse.saga";
import { performanceReportSaga } from "./report/performanceReport/performanceReport.saga";
import { submittedProposalsReportSaga } from "./report/submittedProposalsReport/submittedProposalsReport.saga";
import { rpcNonReportSaga } from "./report/rpcReport/rpcNonReport.saga";
import { averageMonthlyPerformanceReportSaga } from "./report/averageMonthlyPerformanceReport/averageMonthlyPerformanceReport.saga";
// import { RequestReportSaga } from "./report/requestReport/requestReport.saga";
import { webEnquirySaga } from "./report/webEnquiry/webEnquiry.saga";
import { assignUserRightsMasterSaga } from "./assign/assign-users-rights/assign-users-rights.saga";
import { funderMasterSaga } from "./master/funder/funder.saga";
import { DashboardSaga } from "./master/dashboard/Dashboard.saga";
import { saleDetailsSaga } from "./master/leads/saleDetails/saleDetails.saga";

export default function* rootSaga() {
  yield all([
    call(loginSaga),
    // MASTERS
    call(userTypeMasterSaga),
    call(generalSaga),
    call(branchMasterSaga),
    call(departmentMasterSaga),
    call(productMasterSaga),
    call(lenderMasterSaga),
    call(leadsMasterSaga),
    call(staffMasterSaga),
    call(companySaga),
    call(profileSaga),
    call(attendanceSaga),
    call(preproposalsSaga),
    call(diallerPushLogSaga),
    call(searchBusinessDetailsSaga),
    call(callbackSaga),
    call(statusCountSaga),
    call(tcnResponseSaga),
    call(performanceReportSaga),
    call(submittedProposalsReportSaga),
    call(rpcNonReportSaga),
    // call(RequestReportSaga),
    call(averageMonthlyPerformanceReportSaga),
    call(webEnquirySaga),
    call(assignUserRightsMasterSaga),
    call(funderMasterSaga),
    call(DashboardSaga),
    call(saleDetailsSaga),
  ]);
}
